/*
 * @Author: your name
 * @Date: 2021-06-04 09:07:23
 * @LastEditTime: 2021-07-05 18:35:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \element\src\request\axios.js
 */
import axios from "axios";
// import Vue from s'vue';
// import { Message } from "element-ui";
import { getDataType } from "../util/index";
// const baseUrl = process.env.API_ASK
const API_LOGIN = "https://sso.server.gaodun.com";
// Vue.use(Message);
// axios.defaults.baseURL = baseUrl
class HttpRequest {
  interceptors(instance) {
    instance.interceptors.request.use(function (config) {
      // 在发送请求之前做些什么
      const _token = localStorage.getItem('token') || 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJjbGllbnQueGhhZG1pbiIsImF1ZCI6InNlcnZlci54aGFkbWluIiwiaWF0IjoxNjAwODQ5NzE2LCJleHAiOjE2MDA4NTY5MTYsInVpZCI6OX0.5M0UpZKkTs4kWTPNJQxPuHs0FfM1fe2gbr_HMG8c1HQ'

      config.headers["Content-Type"] = 'application/json;charset=UTF-8'
      config.headers["Accept"] = 'application/json'
      _token && (config.headers["Authorization"] = _token)
      return config;
    }, function (error) {
      // 对请求错误做些什么
      return Promise.reject(error);
    });
    // 添加响应拦截器
    instance.interceptors.response.use(function (response) {
      let { status, msg } = response.data;
      if (status == '200') {
        return Promise.resolve(response.data);
      } else if (status == 101 || status == 102) {
        const _token = localStorage.getItem('token')
        localStorage.removeItem('token')
        localStorage.removeItem('wxtoken')
        if (!_token) {
          location.href =
            API_LOGIN +
            "/index/v1/authorizelogin?url=" +
            encodeURIComponent(location.href);
        }
      } else if (status == 201) {
        localStorage.removeItem('token')
        localStorage.removeItem('wxtoken')
        const _token = localStorage.getItem('token')
        if (!_token) {
          location.href =
            API_LOGIN +
            "/index/v1/authorizelogin?url=" +
            encodeURIComponent(location.href);
        }
      } else {
        return Promise.resolve(response);
        // Message.error(
        //   msg
        // );
      }
      // return Promise.resolve(response);
    }, function (error) {
      /**服务器状态码不是200的情况*/
      // Message.error(
      //   error
      // );
      return Promise.reject(error.response);
    });
  };

  request(option) {
    const { url, method = 'get', data } = option;
    let instance = axios.create({
      baseURL:'https://stark.pxo.cn'
    });
    let config = {
      url,
      method: method.toLowerCase(),
      onUploadProgress: option.progress
    };
    if (config.method === "put" || config.method === "post" || config.method === "patch") {
      data && (config["data"] = data);
    } else {
      data && (config["params"] = filterData(data));
    }
    instance.defaults.timeout = 60000000;
    this.interceptors(instance);
    return instance(config)
  }
}

const filterData = (data) => {
  let rData = {};
  for (let prop in data) {
    if (data.hasOwnProperty(prop)) {
      if (((getDataType(data[prop]) === "string" || getDataType(data[prop]) === "number") && data[prop] !== "") || ((getDataType(data[prop]) === 'array') && data[prop].length)) {
        rData[prop] = data[prop];
      }
    }
  }
  return rData
};
let $axios = new HttpRequest()
export default $axios;
